import { cn } from '@cobliteam/colib-ui/cn';
import type { Variants } from 'motion/react';
import { m } from 'motion/react';
import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';

export interface FileChartLineIconHandle {
  startAnimation: () => void;
  stopAnimation: () => void;
}

interface FileChartLineIconProps extends HTMLAttributes<HTMLDivElement> {
  size?: number;
  isHovered: boolean;
}

const variants: Variants = {
  normal: {
    pathLength: 1,
    opacity: 1,
  },
  animate: {
    pathLength: [0, 1],
    opacity: [0, 1],
    transition: {
      delay: 0.15,
      duration: 0.3,
      opacity: { delay: 0.1 },
    },
  },
};

const FileChartLineIcon = forwardRef<FileChartLineIconHandle, FileChartLineIconProps>(({ className, size = 28, isHovered, ...props }, _) => {
  const variant = isHovered ? 'animate' : 'normal';

  return (
    <div className={cn(className)} {...props}>
      <svg
        data-testid='lucide-file-chart-line'
        xmlns='http://www.w3.org/2000/svg'
        width={18}
        height={18}
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <path d='M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z' />
        <path d='M14 2v4a2 2 0 0 0 2 2h4' />
        <m.path d='m8 17 2.5-2.5 2 2L16 13' variants={variants} animate={variant} />
      </svg>
    </div>
  );
});

FileChartLineIcon.displayName = 'FileChartLineIcon';

export { FileChartLineIcon };
